import { DomSanitizer } from "@angular/platform-browser";
import { Block } from "./model/block.model";

export function get2025EarthDayW1(sanitizer: DomSanitizer): Block[] {
    return [
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/2025碩達世界地球日_2.jpg",
            blockImgName: "",
            blockIndex: 0,
            blockName: "block1",
            blockType: 8,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 0,
            blockName: "block1",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 18px; text-align: left; color: black; margin-top: 20px">🌍世界地球日今天啟動啦！(cracker)<br>' +
                    "大家準備好，和我們一起**「陪地球練笑肌」**了嗎？🐝<br>" +
                    "這次碩達推出 【#EarthDayWithSOLARIX 21天行動計畫】，<br>" +
                    "每天一點點，從習慣開始，一起玩出永續的新節奏！<br>" +
                    "有什麼內容？<br>" +
                    "☀️每天一則永續小知識<br>" +
                    "⭐️每天一個可愛小任務<br>" +
                    "🍀每天一個減碳小習慣<br>" +
                    "還有社群互動、打卡分享、最重要的——我們自己的挑戰！<br>" +
                    "🏆專屬 bonus 挑戰來囉！<br>" +
                    "這次，我們要來點真的！<br>" +
                    "請大家到留言區寫下自己想做的「21天挑戰目標」！🎯<br>" +
                    "目標不限主題，愈創意愈好！<br>" +
                    "看別人想做什麼你也想跟？可以直接按讚加入！<br>" +
                    "例如：<br>" +
                    "☑️「我21天不叫外送」→ 可以截圖Uber訂單，一路空白到第21天超爽感爆棚！<br>" +
                    "☑️「我21天澆水、曬太陽、跟家裡的植物說早安」→ 心情 +1、碳足跡 -1！<br>" +
                    "☑️「我21天騎腳踏車通勤」→ 那條熟悉的馬路，今天變得比較綠了！<br>" +
                    "________________________________________<br>" +
                    "怎麼參加？<br>" +
                    "自發性留言你想挑戰的目標（可以一項，也可以三項！）<br>" +
                    "投票＋響應其他人的挑戰<br>" +
                    "<a href='https://www.facebook.com/share/p/15pB6uRjUz/' target='_blank' style='color:rgb(0, 93, 214)'>加入碩達FB粉專</a>跟著21天活動一起打卡、分享、互相加油🔥<br>" +
                    "線上線下都可以參與！親友、同事、全家都歡迎加入！<br>" +
                    "________________________________________<br>" +
                    "最後！還有參與抽獎活動唷！<br>" +
                    "完成挑戰的夥伴有機會參加精美永續好禮抽獎～<br>" +
                    "不只為地球努力，也幫自己累積一點點成就感！<br>" +
                    "________________________________________<br>" +
                    "🤟今天起，我們從「Kibo起步」！<br>" +
                    "用21天，練出自己的永續肌耐力，<br>" +
                    "不硬教條、不浮口號，陪你慢慢變好，陪地球一起微笑 😊<br>" +
                    "#EarthDayWithSOLARIX<br>" +
                    "#21天計畫 #陪地球練笑肌<br>" +
                    "#碩達系統 #Kibo起步 #一起玩起來!!🌏🌟🍀</p>"
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day1.jpg",
            blockImgName: "",
            blockIndex: 1,
            blockName: "block2",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day2.jpg",
            blockImgName: "",
            blockIndex: 2,
            blockName: "block3",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day3.gif",
            blockImgName: "",
            blockIndex: 3,
            blockName: "block4",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day4.jpg",
            blockImgName: "",
            blockIndex: 4,
            blockName: "block5",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day5.jpg",
            blockImgName: "",
            blockIndex: 5,
            blockName: "block6",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day6.jpg",
            blockImgName: "",
            blockIndex: 6,
            blockName: "block7",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day7.jpg",
            blockImgName: "",
            blockIndex: 7,
            blockName: "block8",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
    ];
}
